import { Pipe, PipeTransform } from '@angular/core';
import { DispatchingRuleSearchOrder } from '@app-types/enums/DispatchingRuleSearchOrder';

@Pipe({
  name: 'formatDispatchingRuleSearchOrders',
  standalone: true,
})
export class FormatDispatchingRuleSearchOrders implements PipeTransform {
  transform(order: string): DispatchingRuleSearchOrder {
    switch (order) {
      case 'priority':
        return DispatchingRuleSearchOrder.OrderByPriority;
      case 'name':
        return DispatchingRuleSearchOrder.OrderByName;
      default:
        return DispatchingRuleSearchOrder.OrderByDispatchingRuleId;
    }
  }
}
